export const ReceiveRouting = [
  {
    path: "/quality/receive/list",
    name: "quality-receive-list",
    meta: { title: "质量整改验收" },
    component: () =>
      import(/* webpackChunkName: "quality-receive" */ "@/views/quality/receive/list/index.vue"),
  },
  {
    hidden: true,
    path: "/quality/receive/create",
    name: "quality-receive-create",
    meta: { title: "新增质量整改验收", comName: "QualityReceiveFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "quality-receive" */ "@/views/quality/receive/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/quality/receive/edit/:id",
    name: "quality-receive-edit",
    meta: { title: "编辑质量整改验收", comName: "QualityReceiveFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "quality-receive" */ "@/views/quality/receive/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/quality/receive/flowPrint/:id",
    name: "quality-receive-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "quality-receive" */ "@/views/quality/receive/form-print/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/quality/receive/detail/:id",
    name: "quality-receive-detail",
    meta: { title: "质量整改验收详情" },
    component: () =>
      import(
        /* webpackChunkName: "quality-receive" */ "@/views/quality/receive/form-detail/index.vue"
      ),
  },
];
